exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel-pagination[data-v-b459dca8]{width:100%;text-align:center}.VueCarousel-pagination--top-overlay[data-v-b459dca8]{position:absolute;top:0}.VueCarousel-pagination--bottom-overlay[data-v-b459dca8]{position:absolute;bottom:0}.VueCarousel-dot-container[data-v-b459dca8]{display:inline-block;margin:0 auto;padding:0}.VueCarousel-dot[data-v-b459dca8]{display:inline-block;cursor:pointer;appearance:none;border:none;background-clip:content-box;box-sizing:content-box;padding:0;border-radius:100%;outline:none}.VueCarousel-dot[data-v-b459dca8]:focus{outline:1px solid #add8e6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b459dca8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WebResources/vue/shared/components/VueCarousel/Pagination.vue
// module id = 504
// module chunks = 0 2 5 6 8 9 10 11 12